var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.00025,27.00025 C13.74425,27.00025 13.48825,26.90225 13.29325,26.70725 C12.90225,26.31625 12.90225,25.68425 13.29325,25.29325 L22.58625,16.00025 L13.29325,6.70725 C12.90225,6.31625 12.90225,5.68425 13.29325,5.29325 C13.68425,4.90225 14.31625,4.90225 14.70725,5.29325 L24.70725,15.29325 C25.09825,15.68425 25.09825,16.31625 24.70725,16.70725 L14.70725,26.70725 C14.51225,26.90225 14.25625,27.00025 14.00025,27.00025",
    transform: "matrix(1 0 0 -1 -11.602 28)",
    fillRule: "evenodd"
  })));
};
export default SvgArrow;